export { Slider } from "./Slider"
